<div class="bloque-menu-socios">
    <div class="container">
      <div class="color-claro pb-5">
        <h2>Pacientes</h2>
        <small>Información sobre pacientes registrados</small>
      </div>
  
      <button (click)="initTable()">ACTUALIZAR TABLA</button>

      <!-- Contenedor responsive para la tabla -->
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th><input type="checkbox" (change)="selectAll($event)"></th>
              <th *ngFor="let col of columns">{{ col }}</th>
              <th>Perfil / Seguimientos</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableData">
              <td>
                <input type="checkbox" [checked]="selections.includes(row)" (change)="onRowSelect($event, row)">
              </td>
              <td>{{ row.nombre }}</td>
              <td>{{ row.tipo }}</td>
              <td>{{ row.nroDocumento }}</td>
              
              <!-- <td>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [id]="'reproSwitch' + row.id" 
                    [checked]="row.repro" 
                    [disabled]="true"
                    (change)="toggleRepro(row, $event)">
                </div>
              </td>
              <td>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [id]="'suscripcionSwitch' + row.id" 
                    [checked]="row.suscripcion" 
                    [disabled]="true"
                    (change)="toggleSuscripcion(row, $event)">
                </div>
              </td>-->
              <td class="text-center align-middle">
                <div class="form-check form-switch custom-toggle">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [id]="'reproSwitch' + row.id" 
                    [checked]="row.idReprocan ? true : false" 
                    [disabled]="true"
                    (change)="toggleRepro(row, $event)">
                </div>
              </td>
              <td class="text-center align-middle">
                <div class="form-check form-switch custom-toggle">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [id]="'suscripcionSwitch' + row.id" 
                    [checked]="row.suscripto ? true : false" 
                    [disabled]="true"
                    (change)="toggleSuscripcion(row, $event)">
                </div>
              </td>              
              <td class="action-col">
                <a title="Ir al perfil" style="cursor:pointer">
                  <img src="assets/images/mi-perfil.png" alt="Ir al perfil" width="40" height="40">
                </a>
                <a title="Ir a seguimientos" class="mx-2" style="cursor:pointer">
                  <img src="assets/images/seguimiento.png" alt="Ir a seguimientos" width="40" height="40">
                </a>
                <a title="Editar paciente" style="cursor:pointer">
                  <img src="assets/images/edit.svg" alt="Editar paciente" width="50" height="50">
                </a>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Fin contenedor responsive -->
    </div>
  </div>
  